import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=37504f16&scoped=true"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"
import style0 from "./Facebook.vue?vue&type=style&index=0&id=37504f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37504f16",
  null
  
)

export default component.exports